<template>
    <div class="position-relative">

        <div v-if="this.background_image==''" class="video-wrapper" >
            <video class="video-wrapper__item" playsinline="" autoplay="" muted="" loop="">
            <source src="https://player.vimeo.com/external/371158010.hd.mp4?s=534720792c1dc589d5dc135acd278bdb48956e16&profile_id=174" type="video/mp4">
            </video>
        </div>
        
        <div v-if="this.background_image!=''" class="d-none d-md-inline-block video-overlay" :class="{'cursor-pointer':this.banner_link}" :style="{backgroundImage: `url(${this.background_image})`}" @click="goToLink">
        </div>

        <div class="hero">
            <div class="navbar-menu home" :class="{'menu-is-open': menu_isOpen}">
                <MenuHead></MenuHead>
            </div>
            <b-navbar toggleable="xs" :sticky="true" type="light"
                      :class="{'is-down': !header.going_up && !menu_isOpen}">
                <div class="container">
                    <div class="d-flex align-items-center justify-content-between w-100">
                        <div class="logo-wrapper">
                            <a @click="resetSearch" class="navbar-brand">
                                <img src="../assets/svg/logo-tds-orange.svg"
                                     class="d-inline-block align-top" alt="">
                            </a>
                        </div>
                        <div style="width:500px"><Ads></Ads></div>
                        <div style="display: inline-flex;" class="align-items-center">
                            <div class="d-none d-lg-flex align-items-center justify-content-center w-100 navbar-menu home">
                                <MenuHead></MenuHead>
                            </div>
                            <div class="search-wrapper d-none d-lg-inline-block" v-if="nav_isOpen">
                                <b-form @submit="updateCalendario">
                                    <div class="row position-relative">
                                        <div class="col-lg-3 pr-lg-0 text-left mb-2 mb-lg-0">
                                            <b-form-select v-model="calendario.sport"
                                                           :options="$t('sports')"></b-form-select>
                                        </div>
                                        <div class="col-lg-5 pl-lg-3 pr-lg-0 text-left mb-2 mb-lg-0">
                                            <date-range-picker
                                                    v-model="calendario.picker"
                                                    @update="updateCalendario"
                                                    :locale-data="picker.locale"
                                                    :autoApply="true"
                                                    :ranges="null"
                                                    class="w-100"></date-range-picker>
                                        </div>
                                        <div class="col-lg-4 pr-lg-0 text-left mb-2 mb-lg-0">
                                            <b-form-input v-model="calendario.testo"
                                                          :placeholder="$t('placeholder_ricerca')"
                                                          @input="updateTextCalendario"></b-form-input>
                                            <div class="search-wrapper--alert"
                                                 :class="{'show-help-text': calendario.testo.length <= 2 && calendario.testo.length > 0}">
                                                {{$t('search_box.help_text_min_characters')}}
                                            </div>
                                            <div class="search-wrapper--search-icon-wrapper">
                                                <div @click="nav_isOpen = false"
                                                     class="search-wrapper--search-icon-wrapper--btn">
                                                    <span>{{$t('search_box.search_close_btn')}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-form>
                            </div>
                            <div class="d-flex align-items-center ml-2">
                                <div class="d-inline-block" id="intro-login">
                                    <Login/>
                                </div>
                                <b-navbar-toggle class="ml-lg-3 d-lg-none" v-if="!menu_isOpen"
                                                 @click="menu_isOpen = true; menu_inSearch = false"
                                                 target="nav_collapse"></b-navbar-toggle>
                                <a v-if="menu_isOpen" @click="menu_isOpen = false"
                                   class="search-wrapper--search-icon-wrapper--btn d-inline-block d-lg-none p-0 ml-lg-3">
                                    <img src="../assets/svg/icon-hamburger-close.svg" width="30" height="30">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </b-navbar>
            <div class="container text-center main-content" >
                <div v-if="this.banner_image==''" class="row payoff" :class="{'cursor-pointer':this.banner_link}" @click="goToLink" >
                    <div class="col-md-12" id="top">
                        <transition appear name="slide-fade">
                            <p class="display-4 m-0" v-show="all_loaded">{{$t('payoff')}}</p>
                        </transition>
                    </div>
                </div>
                <div v-if="this.banner_image!=''" class="row payoff d-none d-md-block" :class="{'cursor-pointer':this.banner_link}"  @click="goToLink">
                    <div class="col-md-12 img-container">
                        <transition appear name="slide-fade">
                            <img :src="`${this.banner_image}`">                            
                        </transition>
                    </div>
                </div>

                <div v-if="!header.going_up && !menu_isOpen" class="is-fix">
                    <div class="row">
                        <div class="col-12 d-flex justify-content-center align-items-center">
                            <div class="box-result d-flex justify-content-center align-items-center text-uppercase">
                                <span v-if="!calendario.searchOld">{{$t('search_box.next_races')}}</span>
                                <span v-if="calendario.searchOld">{{$t('search_box.results')}}</span>
                            </div>
                            <div class="d-flex justify-content-center align-items-center" v-scroll-to="'#top'">
                                <!--<i class="arrow up"></i>-->
                                <img src="../assets/up.svg" alt="">
                            </div>
                        </div>

                    </div>
                </div>
                <div class="container rounded event-wrapper mb-4 d-inline-block position-relative">
                    <div class="row">
                        <div class="col-12 mega-wrapper-search" :class="{'is-active': !menu_isOpen}">
                            <div class="search-wrapper row">
                                <div class="col-lg-3 button-wrapper"
                                >
                                    <a @click="setSearchOld(false)" class="next_races"
                                       :class="{'is-active':!calendario.searchOld}">{{$t('search_box.next_races')}}</a>
                                    <a @click="setSearchOld(true)" class="results"
                                       :class="{'is-active':calendario.searchOld }">{{$t('search_box.results')}}</a>
                                </div>
                                <b-form @submit="updateCalendario" class="free-search col-lg-5"
                                        :class="{'hide-block': search_isOpen}">
                                    <div class="free-text">
                                        <b-form-input class="d-inline-block" v-model="calendario.testo"
                                                      :placeholder="$t('placeholder_ricerca')"
                                                      @input="updateTextCalendario"
                                                        autocomplete="off"
                                        ></b-form-input>
                                        <div class="search-wrapper--alert"
                                             :class="{'show-help-text': calendario.testo.length <= 2 && calendario.testo.length > 0}">
                                            {{$t('search_box.help_text_min_characters')}}
                                        </div>
                                        <img class="close-icon" src="../assets/svg/icon-hamburger-close.svg"
                                             @click="resetSearch" v-if="calendario.testo.length > 0">
                                    </div>
                                </b-form>
                                <div class="col-lg-2 offset-lg-2 advanced-search"
                                     :class="{'is-fixed': !header.going_up && !menu_isOpen,'is-active': search_isOpen}">
                                    <span class="text" @click="search_isOpen = true">{{$t('search_box.advanced_search')}}</span>
                                    <span class="close"
                                          @click="resetSearch">{{$t('search_box.advanced_search_close')}}</span>
                                </div>
                            </div>


                            <div class="row search-wrapper-advanced-search" :class="{'is-active':search_isOpen}">
                                <div class="col-lg-3 mt-1 mt-lg-0">
                                    <b-form-select v-model="calendario.sport" :options="$t('sports')"></b-form-select>
                                </div>
                                <!--<div class="col-lg-3 wrapper-input mt-1 mt-lg-0"  id="intro-calendar">-->
                                <!--<date-range-picker ref="intro-calendar-picker"-->
                                <!--v-model="calendario.picker"-->
                                <!--:locale-data="picker.locale"-->
                                <!--:autoApply="true"-->
                                <!--:ranges="picker.ranges"-->
                                <!--:min-date="calendario.picker.minDate"-->
                                <!--:max-date="calendario.picker.maxDate"-->
                                <!--class="w-100"></date-range-picker>-->
                                <!--</div>-->
                                <div class="col-lg-3 wrapper-input mt-1 mt-lg-0">
                                    <select class="custom-select" v-model="calendario.periodo"
                                            v-if="calendario.searchOld">
                                        <option v-for="option in calendario.periodi" v-bind:value="option.value"
                                                v-bind:key="option.value">
                                            {{ option.text }}
                                        </option>
                                    </select>
                                </div>
                                <b-form @submit="updateCalendario" class="free-search col-lg-3">
                                    <div class="free-text">
                                        <b-form-input class="d-inline-block" v-model="calendario.testo"
                                                      :placeholder="$t('placeholder_ricerca')"></b-form-input>
                                        <div class="search-wrapper--alert"
                                             :class="{'show-help-text': calendario.testo.length <= 2 && calendario.testo.length > 0}">
                                            {{$t('search_box.help_text_min_characters')}}
                                        </div>
                                        <img class="close-icon" src="../assets/svg/icon-hamburger-close.svg"
                                             @click="calendario.testo = ''" v-if="calendario.testo.length > 0">
                                    </div>
                                </b-form>
                                <div class="col-lg-2 offset-lg-1 mt-1 mt-lg-0 text-right">
                                    <a @click="updateCalendario" href="" class="btn btn-primary update-calendar">{{$t('search_box.filter_cta')}}</a>
                                </div>
                                <div class="col-12 advanced-search"
                                     :class="{'is-fixed': !header.going_up && !menu_isOpen,'is-active': search_isOpen}">
                                    <span class="text" @click="search_isOpen = true">{{$t('search_box.advanced_search')}}</span>
                                    <span class="close"
                                          @click="resetSearch">{{$t('search_box.advanced_search_close')}}</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="no-event-slot row" v-if="calendario.data.length <= 0">
                        <div class="col-lg-8 offset-lg-2 pt-2 pt-lg-5 pb-5 pb-lg-10">
                            <div class="no-event-slot__title">{{$t('no_event_slot.title')}}</div>
                            <div class="no-event-slot__subtitle">{{$t('no_event_slot.subtitle')}}</div>
                        </div>
                    </div>
                    <transition-group name="slide-up" tag="div" class="row mt-2 mt-lg-0 pl-md-3 pr-md-3"
                                      v-if="gare.length">
                        <article class="col-md-6 col-lg-4 col-xl-4" :class="{'sponsor-item':gara.banner}"
                                 v-for="gara in gare" :key="gara.ID">
                            <div v-if="gara.banner" class="sponsor-item__header">
                                <div class="sponsor-item__header__title">{{$t('adv_banner.single_title')}}</div>
                                <div class="sponsor-item__header__info" id="sponsor-item__header__info--tooltip">
                                    <img src="../assets/svg/info-icon.svg">
                                    <b-popover target="sponsor-item__header__info--tooltip" triggers="hover click"
                                               placement="top">
                                        <div v-html="$t('adv_banner.cta')"></div>
                                    </b-popover>
                                </div>
                            </div>
                            <div class="race-item--wrapper" v-if="gara.banner">
                                <div class="sponsor-item__img">
                                    <a :href="gara.banner.LinkUrl" target="_blank">
                                        <div class="sponsor-item__img-bg"
                                             :style="{ backgroundImage: 'url('+gara.banner.ImageUrl+')' }"></div>
                                        <img :src="gara.banner.ImageUrl">
                                    </a>
                                </div>
                            </div>
                            <div class="race-item--wrapper" v-else
                                 :class="{'no-animation':services_panel_isOpen === gara.ID}">
                                <div class="race-item__services-panel" :class="{'is-open':services_panel_isOpen}"
                                     v-if="services_panel_isOpen === gara.ID">
                                    <div class="group-link row">
                                        <div class="group-link--row col pr-0 pl-4">
                                            <a class="col btn btn-light text-secondary d-flex align-items-center justify-content-center"
                                               v-if="services_panel_isOpen === gara.ID"
                                               @click="services_panel_isOpen = 0">{{$t('close')}}</a>
                                        </div>
                                        <div class="group-link--row col pr-4">
                                            <router-link class="col btn more"
                                                         :to="{ name: 'race', params: { id: gara.ID }}">
                                                {{$t('go_to')}} <img class="ml-1"
                                                                     src="../assets/svg/icon_arrow-right_dark_orange.svg"
                                                                     height="10">
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="race-item__services-panel--services-race-availables">
                                        <div class="race-item__services-panel--services-race-availables--label">
                                            {{$t('services_list.title_2')}}<br>{{gara.Description}}<br>{{$t('services_list.of_the')}}
                                            {{gara.RaceDate | date}}
                                        </div>
                                        <div class="race-item__services-panel--services-race-availables-disponibili">
                                            <Services :services="gara.Services"></Services>
                                        </div>

                                    </div>
                                </div>
                                <div class="race-item--wrapper--body--title">
                                    <div class="race-item--wrapper--media">
                                        <router-link class="w-100 h-100" :to="{ name: 'race', params: { id: gara.ID }}">
                                            <img class="race-item--wrapper--media--image" :src="gara.ImageUrl">
                                        </router-link>
                                    </div>
                                    <div class="race-item--wrapper--body">
                                        <div class="race-item--wrapper--body--content">
                                            <router-link :to="{ name: 'race', params: { id: gara.ID }}">
                                                <div class="race-item--wrapper--body--race-type">
                                                    {{gara.DisciplineID | sport}}
                                                </div>
                                                <div class="race-item--wrapper--body--eyebrow">
                                                    {{gara.RaceDate | date}}
                                                </div>
                                                <div class="race-item--wrapper--body--title">{{gara.Description}}</div>
                                                <div class="race-item--wrapper--body--subtitle">
                                                    <!--<div class="location"><span class="text">{{// gara.Location}}</span></div>-->
                                                    {{gara.Location}}
                                                </div>
                                            </router-link>
                                        </div>
                                        <div class="race-item--wrapper--body--footer">
                                            <div class="group-link row">
                                                <div class="group-link--row col pr-0">
                                                    <a class="col btn btn-light text-secondary"
                                                       @click="services_panel_isOpen = gara.ID">{{$t('details')}}</a>
                                                </div>
                                                <div class="group-link--row col">
                                                    <router-link class="col btn more"
                                                                 :to="{ name: 'race', params: { id: gara.ID }}">
                                                        {{$t('go_to')}} <img class="ml-1"
                                                                             src="../assets/svg/icon_arrow-right_dark_orange.svg"
                                                                             height="10">
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </transition-group>

                    <div v-if="calendario.loading">Loading...</div>
                    <div v-if="calendario.numElem < calendario.tot && calendario.tot > calendario.numPerPage ">
                        <b-button
                                variant="btn btn-light btn-lg btn-gare-precedenti"
                                v-on:click="getMoreResults">
                            <span>{{$t('altri_eventi')}}</span>
                        </b-button>
                    </div>

                    <div class="col-12" v-if="calendario.tot > calendario.numPerPage">
                        <!--<b-pagination class="justify-content-center mt-5" :total-rows=Number(calendario.tot)-->
                        <!--v-model="calendario.pag" :per-page="calendario.numPerPage"-->
                        <!--@change="getCalendario"></b-pagination>-->
                        <div class="col text-center text-muted py-4">
                            {{numero_elementi}} di {{calendario.tot}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="banner-section__wrapper" :class="{'is-shown': showBanner,'static':!showBanner}"
             v-show="banner.home.length">
            <div class="container">
                <div class="banner-section">
                    <div class="row position-relative">
                        <div class="col-12 banner-section--heading" v-if="showBanner">
                            <div class="banner-section--heading--close" @click="closeBanner">
                                <span class="mr-1">{{$t('close')}}</span>
                                <img src="../assets/svg/icon-close-orange.svg" height="15">
                            </div>
                        </div>
                        <!-- numSlide -->
                        <carousel class="col-12 banner-section--carousel" :per-page="numSlide" :scrollPerPage="true"
                                  :centerMode="true" :autoplay="true" :loop="true">
                            <slide v-for="ban in banner.home" :key="ban.ID" class="banner-section--item">
                                <a class="d-inline-block" :href="ban.LinkUrl" target="_blank"
                                   :title="ban.Description"><img data-inject-svg class="img-fluid" :src="ban.ImageUrl"></a>
                            </slide>
                        </carousel>
                    </div>
                </div>
            </div>
        </div>
        <!--        <div class="tips-howusetds" v-if="introDone" @click="startIntro">-->
        <!--            <img src="../assets/svg/help-icon.svg">-->
        <!--            <span>{{$t('tips_howusetds.title')}}</span>-->
        <!--        </div>-->
        <TDSFoot/>
    </div>
</template>

<style>
    .slide-fade-enter-active {
        transition: all 1.5s ease;
    }

    .slide-fade-enter, .slide-fade-leave-to {
        transform: translateX(-150px);
        opacity: 0;
    }

    .slide-up-enter-active {
        transition: all 1.5s ease;
    }

    .slide-up-enter, .slide-up-leave-to {
        transform: translateY(20px);
        opacity: 0;
    }


</style>

<script>
    import Login from '../components/Login'
    import MenuHead from '../components/MenuHead'
    import Ads from '../components/Ads'
    import BaseVue from './BaseVue'
    import debounce from 'lodash/debounce'
    import DateRangePicker from 'vue2-daterange-picker'
    //you need to import the CSS manually (in case you want to override it)
    import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css'
    import {Carousel, Slide} from 'vue-carousel'

    import Services from '../components/Services'

    export default {
        extends: BaseVue,
        name: 'home',
        components: {
            Services,
            MenuHead,
            Ads,
            DateRangePicker,
            Carousel,
            Slide,
            Login
        },
        data() {
            return {
                nav_isOpen: false,
                menu_isOpen: false,
                menu_inSearch: false,
                search_isOpen: false,
                services_panel_isOpen: 0,
                old_url: '',
                ritardoBanner: 5, // Ritardo banner in secondi
                altezzaAttivazioneBanner: -1, // Altezza in PX per l'attivazione del banner
                header: {
                    totScroll: 0,
                    scroll_position: 0,
                    going_up: true,
                    min_position: 500,
                },
                scrollPos: 0,
                timeoutBanner: false,
                hideBanner: false,
                all_loaded: false,
                banner: {
                    home: [],
                    top: []
                },
                calendario: {
                    searchOld: false,
                    loading: false,
                    data: [],
                    sport: -1,
                    nazione: -1,
                    pag: 1,
                    tot: 0,
                    numPerPage: 12,
                    testo: '',
                    numElem: 0,
                    periodo: '1-year',
                    periodi: []
                },
                screenSize: 0,
                introDone: false,
            }
        },
        metaInfo() {
            return {
                title: 'TDS.sport – powered by your emotions',
                meta: [
                    {
                        name: 'description',
                        content: 'Timing Data Service nasce ufficialmente nel 2004 ed è oggi la timing company leader a livello nazionale per numero di atleti cronometrati (350.000 atleti ed oltre 1.000.000 di tempi rilevati nel corso dell’ultimo anno) con un trend di crescita sempre positivo sin dalla nascita.\n' +
                            'In parallelo al timing, vengono offerti anche altri servizi: la grafica TV, la gestione delle iscrizioni per conto degli organizzatori, la produzione di materiali (pettorali, volantini, buste, ecc.) e molto altro.'
                    },
                    {og_site_name: 'og:site_name', content: 'TDS – Timing Data Service'},
                    {og_type: 'og:type', content: 'website'},
                    {og_url: 'og:url', content: this.$router.currentRoute.fullPath},
                    {og_image: 'og:image', content: process.env.BASE_URL + 'flags/AFG.gif'},
                    {
                        og_image: 'og:video',
                        content: 'https://player.vimeo.com/external/371158010.hd.mp4?s=534720792c1dc589d5dc135acd278bdb48956e16&profile_id=174'
                    }
                ],
            }
        }, watch: {
            menu_isOpen: function (val) {
                this.$store.commit('menu_open', val)
            },
            menu_inSearch: function (val) {
                this.$store.commit('menu_open', val)
            }
        },
        async mounted() {
            let data = this.$store.getters['home/calendario']
            if (data) {
                this.calendario = data
                this.search_isOpen = data.search_isOpen
            }

            if (sessionStorage.getItem('hideBanner'))
                this.hideBanner = true


            this.screenSize = window.innerWidth
            window.addEventListener('resize', () => {
                this.screenSize = window.innerWidth
            })
            window.addEventListener('resize', () => {
                this.screenSize = window.innerWidth
            })
            window.addEventListener('scroll', this.handleScroll)
            window.addEventListener('scroll', this.headScroll)

            this.makePeriodi()
            this.getBanner()
            await this.getCalendario(this.calendario.pag)

            // this.setupIntro()

        }, computed: {
            banner_link() {
              return this.$store.getters.banner_link
            },
            banner_image() {
              return this.$store.getters.banner_image
            },
            background_image() {
              return this.$store.getters.background_image
            },
            gare() {
                if (this.calendario.data.length <= 0)
                    return []
                //               if (this.calendario.pag > 1)
                //                   return this.calendario.data
                if (this.banner.top.length <= 0)
                    return this.calendario.data

                let gare = []
                let banner = this.banner.top
                let numPerPage = this.calendario.numPerPage - this.banner.top.length
                let numElem = Math.min(this.calendario.data.length, numPerPage)
                for (let i = 0; i < numElem; i++) {
                    if (banner.length === 1) {
                        if (i === 4)
                            gare.push({'banner': banner[0], ID: 'banner_0'})
                    } else if (banner.length === 2) {
                        if (i === 3)
                            gare.push({'banner': banner[0], ID: 'banner_0'})
                        if (i === 4) // N.b. questo è il num elme, in realtà poi finirà nella posizione 5 ( inserisco infatti il banner nel 3, poi l'elemento 3 che finisce nel 4, inserisco il banner che finisce nel 5 e poi l'elemento 6  )
                            gare.push({'banner': banner[1], ID: 'banner_1'})
                    }

                    gare.push(this.calendario.data[i])
                }
                return gare
            },
            numSlide() {
                if (this.banner.home.length <= 0) return 1

                if (this.screenSize <= 769)
                    return Math.min(1)
                return Math.min(4, this.banner.home.length)
            }, showBanner() {
                if (this.hideBanner) return false
                if (!this.timeoutBanner) return false
                if (this.scrollPos > this.altezzaAttivazioneBanner) return true
                return false
            },
            numero_elementi() {
                if (this.calendario.numElem === 0) {
                    return 12
                } else {
                    return this.calendario.numElem
                }
            }
        }, methods: {
            goToLink() {
              if (this.banner_link)
                window.open(this.banner_link);
            },
            closeBanner() {
                this.hideBanner = true
                sessionStorage.setItem('hideBanner', 'true')
            },
            fixDays(days) {
                // Disabilitato il fix, che non serve più.. ma non si capisce perchè prima serviva
                return days
                // let ret = []
                // ret[0] = days[6]
                // for (let i = 0; i <= 5; i++)
                //     ret[i + 1] = days[i]
                // return ret
            },
            handleScroll() {
                if (this.hideBanner) {
                    window.removeEventListener('scroll', this.handleScroll)
                    return
                }

                let supportPageOffset = window.pageYOffset !== undefined
                let isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat')
                // Verifico di quanto siamo scrollati verticalmente
                this.scrollPos = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop
               // console.log(this.scrollPos)
            },
            getCalendario: async function (pag) {
                let url = 'search/race'
                if (this.calendario.nazione !== -1) url += '/c/' + this.calendario.nazione // Filtro per nazione

                let ndays = 364
                if (this.calendario.searchOld) {
                    let end = null
                    if (isNaN(this.calendario.periodo)) {
                        end = this.$moment()
                        if (this.calendario.periodo === 'last-30-days') ndays = 30
                        ndays = '-' + ndays
                    }
                    else
                        end = this.$moment().year(parseInt(this.calendario.periodo)).dayOfYear(1)
                    url += '/d/' + end.format('YYYY-MM-DD') + '/r/' + ndays // Gare nei prossimi X giorni
                }
                else {
                    let begin = this.$moment()
                    url += '/d/' + begin.format('YYYY-MM-DD') + '/r/' + ndays // Gare nei prossimi X giorni
                }

                if (this.calendario.sport !== -1) url += '/d/' + this.calendario.sport // Filtro per sport
                if (this.calendario.testo.length > 2) url += '/' + encodeURIComponent(this.calendario.testo) // Filtro testo libero

                let offset = ((pag - 1) * this.calendario.numPerPage + 1)
                if (pag > 1) offset -= this.banner.top.length // Tengo conto del fatto che nella prima pagina non ho mostrato tutti i banner ma ne ho esclusi 1 o 2 in base al numero di banner
                url += '/' + offset + '/' + this.calendario.numPerPage // Paginazione

                if (this.calendario.searchOld) url += '/desc'  // Se sto cercando le vecchie gare cerco al contrario in modo da avere prima le più recenti

                if (this.old_url === url)
                    return true

                this.old_url = url

                // if (this.calendario.testo.length > 2) this.track('search','engagement','search_term',this.calendario.testo)
                // if (this.calendario.sport !== -1) this.track('search','engagement','sport',this.calendario.testo)


                if (pag === 1) {
                    let result = await this.get(url, true)
                    this.calendario.data = []
                    this.calendario.tot = 0
                    this.calendario.search_isOpen = this.search_isOpen
                    this.$store.dispatch('home/calendario', this.calendario)
                    this.all_loaded = true

                    // Tengo conto del fatto che nella prima pagina non ho mostrato tutti i banner ma ne ho esclusi 1 o 2 in base al numero di banner
                    this.calendario.numElem = this.calendario.data.length
                    this.calendario.data = result.RaceList
                    this.calendario.tot = result.Status.RecordCount
                }
                else {
                    this.calendario.loading = true
                    let result = await this.get(url, false)
                    this.calendario.loading = false

                    for (let i = 0; i < result.RaceList.length; i++)
                        this.calendario.data.push(result.RaceList[i])
                    this.calendario.numElem = this.calendario.data.length
                    this.calendario.tot = result.Status.RecordCount
                }
                this.calendario.numElem -= this.banner.top.length


                if (!this.timeoutBanner) {
                    setTimeout(() => {
                        this.timeoutBanner = true
                    }, this.ritardoBanner * 1000)
                }

            }, async updateCalendario(e) {
                //this.menu_inSearch = false
                //this.search_isOpen = false
                this.menu_isOpen = false
                if (e) e.preventDefault()
                this.calendario.pag = 1
                await this.$nextTick()
                this.getCalendario(this.calendario.pag)
            }, async setSearchOld(old) {
                if (this.calendario.searchOld === old)
                    return true

                this.calendario.pag = 1
                this.calendario.searchOld = old
                this.calendario.periodo = '1-year'
                await this.$nextTick()
                this.getCalendario(this.calendario.pag)
            }, getMoreResults: function () {
                //if (this.calendario.pag < this.calendario.numElem)
                this.calendario.pag++
                this.getCalendario(this.calendario.pag)
            },
            updateTextCalendario: debounce(function () {
                this.updateCalendario()
            }, 800), async getBanner() {
                let data = await this.get([
                    '/ads/web.home',
                    '/ads/web.top',
                ])
                this.banner.home = data[0].BannerList
                this.banner.top = data[1].BannerList

                if (this.calendario.pag === 1)
                    this.calendario.numElem = this.calendario.data.length - this.banner.top.length // Tengo conto del fatto che nella prima pagina non ho mostrato tutti i banner ma ne ho esclusi 1 o 2 in base al numero di banner


            }, headScroll() {
                let old_pos = this.header.scroll_position

                let supportPageOffset = window.pageYOffset !== undefined
                let isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat')
                // Verifico di quanto siamo scrollati verticalmente
                let new_pos = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTo

                // Su alcuni browser ( chrome, opera ) alla comparsa/scomparsa dell'header si allunga la pagina e pensa che ci sia stato uno scroll
                let size = document.documentElement.getBoundingClientRect()
                let totScroll = size.height + size.top
                if (this.header.totScroll !== totScroll)
                    this.header.totScroll = totScroll
                else {
                    this.header.scroll_position = new_pos
                    return
                }

                let diff = new_pos - old_pos
                if (diff > 0)
                    this.header.going_up = false
                if (diff < 0)
                    this.header.going_up = true

                if (this.header.scroll_position < this.header.min_position)
                    this.header.going_up = true

                if (Math.abs(diff) > 0) {
                    this.header.scroll_position = new_pos
                }
            }, resetSearch(e) {
                this.search_isOpen = false
                this.calendario.testo = ''
                this.calendario.sport = -1
                this.updateCalendario(e)
            }, async setupIntro() {


                // Prima di tutto verifico se l'ho già skippato
                let done = localStorage.getItem('intro_done')
                this.introDone = done
                if (done) return

                let intro = this.$intro()
                this.createStepIntro(intro)
                intro.start() // start the guide
            }, async createStepIntro(intro) {
                if (window.scrollY) {
                    window.scroll(0, 0)
                    await this.sleep(500)

                }

                let inMobile = this.isMobile()
                if (!inMobile) {
                    intro.addStep({
                        element: document.querySelectorAll('#intro-calendar')[0],
                        intro: this.$t('intro.step_calendar'),
                    })
                    intro.addStep({
                        element: document.querySelectorAll('#intro-calendar')[0],
                        intro: this.$t('intro.step_date'),
                        // tooltipClass: 'intro-calendar-tooltip'
                    })
                    intro.addStep({
                        element: document.querySelectorAll('#intro-search-btn  ')[0],
                        intro: this.$t('intro.step_search'),
                    })

                    if (!this.$store.getters.disableLogin) {
                        intro.addStep({
                            element: document.querySelectorAll('#intro-login')[0],
                            intro: this.$t('intro.step_login'),
                        })
                    }
                } else {
                    intro.addStep({
                        element: document.querySelectorAll('#intro-mobile-search')[0],
                        intro: this.$t('intro.step_menu'),
                    })
                    intro.addStep({
                        element: document.querySelectorAll('#intro-mobile-calendar')[0],
                        intro: this.$t('intro.step_date'),
                        // tooltipClass: 'intro-calendar-tooltip'
                    })
                    intro.addStep({
                        element: document.querySelectorAll('#intro-mobile-do-search')[0],
                        intro: this.$t('intro.step_search'),
                    })

                    if (!this.$store.getters.disableLogin) {
                        intro.addStep({
                            element: document.querySelectorAll('#intro-login')[0],
                            intro: this.$t('intro.step_login'),
                        })
                    }
                }

                intro.addStep({
                    element: document.querySelectorAll('.group-link')[0],
                    intro: this.$t('intro.step_detail'),
                })

                let _ = this
                intro.onbeforechange(async step => {
                    if (inMobile) {
                        if (step.id === 'intro-mobile-search')
                            _.menu_inSearch = false
                        else if (step.id === 'intro-mobile-calendar')
                            _.menu_inSearch = true
                        else if (step.id === 'intro-mobile-do-search')

                            _.menu_inSearch = true
                        else if (step.id === 'intro-login') {
                            _.menu_inSearch = false
                            window.scroll(0, 0)
                        }

                        await _.$nextTick()
                    }
                })


                intro.onexit(() => {
                    localStorage.setItem('intro_done', 'true')
                    this.introDone = true
                })

                intro.setOption('skipLabel', this.$t('intro.skip'))
                intro.setOption('nextLabel', this.$t('intro.next'))
                intro.setOption('prevLabel', this.$t('intro.prev'))
                intro.setOption('doneLabel', this.$t('intro.done'))
                intro.setOption('scrollToElement', true)
                intro.refresh()
            }, async startIntro() {
                let intro = this.$intro()
                await this.createStepIntro(intro)
                this.introDone = false
                intro.start() // start the guide
            }, sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms))
            }, makePeriodi() {
                this.calendario.periodi = []
                this.calendario.periodi.push({value: 'last-30-days', text: this.$t('filter.last_30_days')})
                this.calendario.periodi.push({value: '1-year', text: this.$t('filter.this_year')})
                let year = new Date().getFullYear()
                for (let i = year - 1; i >= 2003; i--)
                    this.calendario.periodi.push({value: i, text: i})
            }
        }
    }
</script>
